import React, { Component } from 'react';
import { Table, Row, Col, InputNumber, Button, DatePicker, message, Spin, Input } from 'antd';
import moment from 'moment';
import imgSave from "../../saveImg";
import { data3_2_1, data1, data2 } from './data';
import Auth from "../../Auth";

const { MonthPicker } = DatePicker;
const { TextArea } = Input;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data1: [],
            data2: [],
            data3: [],
            data4: [],
            data5: [],
            data3_1: [],
            loading: true,
            loadingSave: false,
            print: false
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
        // this.computeNum(this.state.data)
    }



    computeNum = (data) => {
        const numConvert = (num = 0) => {
            num = Number(num || "0")
            return num
        };

        this.setState({
            data
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getDateData = async (date) => {
        const dataBegin = JSON.stringify(data3_2_1);
        let data1_1 = JSON.parse(dataBegin);
        const dataBegin1 = JSON.stringify(data1);
        let data2_2 = JSON.parse(dataBegin1);
        const dataBegin2 = JSON.stringify(data1);
        let data3 = JSON.parse(dataBegin2);
        const dataBegin3 = JSON.stringify(data2);
        let data4 = JSON.parse(dataBegin3);
        fetch(`/_2_7_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data._2_7_00 && x.data._2_7_00.length > 0) {
                data1_1 = x.data._2_7_00;
            }
            if (x.data._2_7_01 && x.data._2_7_01.length > 0) {
                data2_2 = x.data._2_7_01;
            }
            if (x.data._2_7_02 && x.data._2_7_02.length > 0) {
                data3 = x.data._2_7_02;
            }
            if (x.data._2_7_03 && x.data._2_7_03.length > 0) {
                data4 = x.data._2_7_03;
            }
            this.setState({
                loading: false,
                data3_1: x.data._3_1_1 || [],
                data1: data1_1,
                data2: data2_2,
                data3,
                data4,
                data5: x.data._2_7_1 || [],
            });
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data1 = this.state.data1.map(x => ({ ...x, year, month }));
        let data2 = this.state.data2.map(x => ({ ...x, year, month }));
        let data3 = this.state.data3.map(x => ({ ...x, year, month }));
        let data4 = this.state.data4.map(x => ({ ...x, year, month }));
        let data5 = this.state.data5.map(x => ({ ...x, year, month }));

        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify({
            _2_7_00: data1,
            _2_7_01: data2,
            _2_7_02: data3,
            _2_7_03: data4,
            _2_7_1: data5,
        }));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_2_7', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data1[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table2_7', 1.5, '3.10', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const data = this.state.data;
        const width = (document.body.offsetWidth - 1250) > 300 ? (document.body.offsetWidth - 1250) : 300;

        const columns = [{
            title: 'Comp Set 竞争集群',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 300,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding `} style={{ textAlign: "left" }}>
                        {text}
                    </div>
                )
            }
        }, {
            title: <div>Score</div>,
            dataIndex: 'score',
            key: 'score',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                return (
                    <div className="table-padding table-color-number">
                        <InputNumber
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            precision={2}
                            className="table_numInput"
                            defaultValue={Number(text || "0") || ''}
                            onBlur={(e) => {
                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                value = Number(value.toFixed(2));
                                let data = this.state.data1;
                                data[index].score = value;
                                this.setState({
                                    data1: data
                                });
                            }}

                        />
                    </div>
                )
            }
        }, {
            title: <div>Action Plan 行动计划  <br />(Please clarify, if the scores are less than 4.5. 若分数小于4.5，需解释)</div>,
            dataIndex: 'action_plan',
            key: 'action_plan',
            align: "center",
            width: 350,
            render: (text, record, index) => {
                return (
                    <div className="table-padding table-color-number">
                        <Input
                            className="table_numInput"
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                let data = this.state.data1;
                                data[index].action_plan = value;
                                this.setState({
                                    data1: data
                                });
                            }}

                        />
                    </div>
                )
            }
        }];

        const columns1 = [{
            title: <div>Best Comments Top 3 最佳评论前三位</div>,
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 300,
            render: (text, record, index) => {
                return (
                    <div className="table-padding table-color-number">
                        <Input
                            className="table_numInput"
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                let data = this.state.data2;
                                data[index].name = value;
                                data[index].name_code = value;
                                this.setState({
                                    data2: data
                                });
                            }}

                        />
                    </div>
                )
            }
        }, {
            title: <div>Action Plan 行动计划</div>,
            dataIndex: 'action_plan',
            key: 'action_plan',
            align: "center",
            width: 500,
            render: (text, record, index) => {
                return (
                    <div className="table-padding table-color-number">
                        <Input
                            className="table_numInput"
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                let data = this.state.data2;
                                data[index].action_plan = value;
                                this.setState({
                                    data2: data
                                });
                            }}

                        />
                    </div>
                )
            }
        }];

        const columns2 = [{
            title: <div>Worst Comments Top 3 最差评论前三位</div>,
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 300,
            render: (text, record, index) => {
                return (
                    <div className="table-padding table-color-number">
                        <Input
                            className="table_numInput"
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                let data = this.state.data3;
                                data[index].name = value;
                                data[index].name_code = value;
                                this.setState({
                                    data3: data
                                });
                            }}

                        />
                    </div>
                )
            }
        }, {
            title: <div>Action Plan 行动计划</div>,
            dataIndex: 'action_plan',
            key: 'action_plan',
            align: "center",
            width: 500,
            render: (text, record, index) => {
                return (
                    <div className="table-padding table-color-number">
                        <Input
                            className="table_numInput"
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                let data = this.state.data3;
                                data[index].action_plan = value;
                                this.setState({
                                    data3: data
                                });
                            }}

                        />
                    </div>
                )
            }
        }];

        const columns3 = [{
            title: 'Online Channel 在线评论渠道',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            render: (text, record, index) => {
                if ([1, 2].includes(index)) {
                    return {
                        props: {
                            rowSpan: 0
                        }
                    }
                }
                return (
                    <div className={`table-padding `} style={{ textAlign: "left" }}>
                        {text}
                    </div>
                )
            }
        }, {
            title: 'Monitor Index (Current Situation) 监督指数（当前状态）',
            dataIndex: 'monitor_index',
            key: 'monitor_index',
            align: "center",
            width: 500,
            render: (text, record, index) => {
                if ([1, 2].includes(index)) {
                    return {
                        props: {
                            rowSpan: 0
                        }
                    }
                }
                return (
                    <div >
                        <div className={`table-padding`} style={{ textAlign: "left", height: "50%", padding: "10px" }}>
                            {record.monitor_index1}
                        </div>
                        <div className={`table-padding `} style={{ textAlign: "left", height: "50%", borderTop: '1px solid #dcdcdc', padding: "10px" }}>
                            {record.monitor_index2}
                        </div>
                    </div>
                )
            }
        }, {
            title: <div>{this.state.data3_1[0] ? this.state.data3_1[0].name : ""}</div>,
            dataIndex: 'col1',
            key: 'col1',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                if ([1, 2].includes(index)) {
                    return {
                        props: {
                            rowSpan: 0
                        }
                    }
                }
                return (
                    <div className="table-padding table-color-number">
                        <Input
                            className="table_numInput"
                            defaultValue={record.col11}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                let data = this.state.data4;
                                data[index].col11 = value;
                                this.setState({
                                    data4: data
                                });
                            }}

                        />
                        <br />
                        <Input
                            className="table_numInput"
                            defaultValue={record.col12}
                            style={{ marginTop: 10 }}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                let data = this.state.data4;
                                data[index].col12 = value;
                                this.setState({
                                    data4: data
                                });
                            }}

                        />
                    </div>
                )
            }
        }, {
            title: <div>{this.state.data3_1[1] ? this.state.data3_1[1].name : ""}</div>,
            dataIndex: 'col2',
            key: 'col2',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                if ([1, 2].includes(index)) {
                    return {
                        props: {
                            rowSpan: 0
                        }
                    }
                }
                return (
                    <div className="table-padding table-color-number">
                        <Input
                            className="table_numInput"
                            defaultValue={record.col21}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                let data = this.state.data4;
                                data[index].col21 = value;
                                this.setState({
                                    data4: data
                                });
                            }}

                        />
                        <br />
                        <Input
                            className="table_numInput"
                            defaultValue={record.col22}
                            style={{ marginTop: 10 }}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                let data = this.state.data4;
                                data[index].col22 = value;
                                this.setState({
                                    data4: data
                                });
                            }}

                        />
                    </div>
                )
            }
        }, {
            title: <div>{this.state.data3_1[2] ? this.state.data3_1[2].name : ""}</div>,
            dataIndex: 'col3',
            key: 'col3',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                if ([1, 2].includes(index)) {
                    return {
                        props: {
                            rowSpan: 0
                        }
                    }
                }
                return (
                    <div className="table-padding table-color-number">
                        <Input
                            className="table_numInput"
                            defaultValue={record.col31}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                let data = this.state.data4;
                                data[index].col31 = value;
                                this.setState({
                                    data4: data
                                });
                            }}

                        />
                        <br />
                        <Input
                            className="table_numInput"
                            defaultValue={record.col32}
                            style={{ marginTop: 10 }}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                let data = this.state.data4;
                                data[index].col32 = value;
                                this.setState({
                                    data4: data
                                });
                            }}

                        />
                    </div>
                )
            }
        }, {
            title: <div>{this.state.data3_1[3] ? this.state.data3_1[3].name : ""}</div>,
            dataIndex: 'col4',
            key: 'col4',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                if ([1, 2].includes(index)) {
                    return {
                        props: {
                            rowSpan: 0
                        }
                    }
                }
                return (
                    <div className="table-padding table-color-number">
                        <Input
                            className="table_numInput"
                            defaultValue={record.col41}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                let data = this.state.data4;
                                data[index].col41 = value;
                                this.setState({
                                    data4: data
                                });
                            }}

                        />
                        <br />
                        <Input
                            className="table_numInput"
                            defaultValue={record.col42}
                            style={{ marginTop: 10 }}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                let data = this.state.data4;
                                data[index].col42 = value;
                                this.setState({
                                    data4: data
                                });
                            }}

                        />
                    </div>
                )
            }
        }, {
            title: <div>{this.state.data3_1[4] ? this.state.data3_1[4].name : ""}</div>,
            dataIndex: 'col5',
            key: 'col5',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                if ([1, 2].includes(index)) {
                    return {
                        props: {
                            rowSpan: 0
                        }
                    }
                }
                return (
                    <div className="table-padding table-color-number">
                        <Input
                            className="table_numInput"
                            defaultValue={record.col51}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                let data = this.state.data4;
                                data[index].col51 = value;
                                this.setState({
                                    data4: data
                                });
                            }}

                        />
                        <br />
                        <Input
                            className="table_numInput"
                            defaultValue={record.col52}
                            style={{ marginTop: 10 }}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                let data = this.state.data4;
                                data[index].col52 = value;
                                this.setState({
                                    data4: data
                                });
                            }}

                        />
                    </div>
                )
            }
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table2_7" >
                        <Row>3.1 Online Guest Comments 顾客在线评论</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data1: [],
                                        data2: [],
                                        data3: [],
                                        data4: [],
                                        data5: [],
                                        data3_1: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={this.state.data1}
                            size="middle"
                            bordered
                            pagination={false}
                            className="content"
                            scroll={{ x: false }}
                            style={{ width: 800 }}
                            rowKey={(record, index) => index}
                        />
                        <Table
                            columns={columns1}
                            dataSource={this.state.data2}
                            size="middle"
                            bordered
                            pagination={false}
                            scroll={{ x: false }}
                            style={{ width: 800 }}
                            rowKey={(record, index) => index}
                        />
                        <Table
                            columns={columns2}
                            dataSource={this.state.data3}
                            size="middle"
                            bordered
                            pagination={false}
                            scroll={{ x: false }}
                            style={{ width: 800 }}
                            rowKey={(record, index) => index}
                        />
                        <Table
                            columns={columns3}
                            dataSource={this.state.data4}
                            size="middle"
                            bordered
                            pagination={false}
                            rowKey={(record, index) => index}
                        />

                        <Row style={{ marginTop: 20 }}>
                            <TextArea
                                autosize={{ minRows: 4 }}
                                value={this.state.data5[0] ? this.state.data5[0].comments : ""}
                                placeholder="请输入备注！"
                                style={{ marginTop: 10 }}
                                onChange={(e) => {
                                    this.setState({ data5: [{ ...this.state.data5[0], comments: e.target.value }] });
                                }}

                            />
                        </Row>
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_2_7">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                loading={this.state.print}
                                onClick={this.downloadSG}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/2-Analysis/2-7/index.js